export interface UserBase {
    name: string;
    nickname?: string;
    profileImageUrl?: string | null;
    phone: string;
    banMemo?: string;
}

export interface GlobalBanUser extends UserBase {
    appUserId: number;
    banDate: string;
}

export interface AppUserInfo extends UserBase {
    id: number;
}

export interface GlobalBanInitType {
    list: GlobalBanUser[];
    nextPage: string | null;
    isLoading: boolean;
}

export const initialState: GlobalBanInitType = {
    list: [],
    nextPage: null,
    isLoading: false,
};
